import { PageHeader } from "@/components/storefront/PageHeader";
import { Seo } from "@/components/Seo";
import { Skeleton } from "@/components/ui/skeleton";
import { usePageContent } from "@/context/SiteContext";
import { imgUrl } from "@/lib/api";

export default function About() {
  const content = usePageContent("about");
  return (
    <div data-testid="about-page">
      <Seo title={content?.seo_title} description={content?.seo_description} />
      <PageHeader title={content?.title || "About Us"} testId="about-header" />
      <div className="max-w-5xl mx-auto px-4 pb-10 grid md:grid-cols-2 gap-10 items-start">
        {content === null ? (
          <Skeleton className="aspect-[4/3] rounded-xl" />
        ) : (
          content.image && (
            <img src={imgUrl(content.image)} alt="Inside our flower shop" className="rounded-xl aspect-[4/3] object-cover w-full" data-testid="about-image" />
          )
        )}
        <div className="prose prose-neutral dark:prose-invert max-w-none">
          {(content?.body || "").split("\n\n").map((para, i) => (
            <p key={i} className="text-muted-foreground leading-relaxed mb-4" data-testid={`about-para-${i}`}>{para}</p>
          ))}
        </div>
      </div>
    </div>
  );
}
